module.exports = __webpack_public_path__ + "img/3.da9ef5e1.png";